import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonMenuButton, IonPopover, IonText, IonToolbar } from "@ionic/react";
import { appsOutline, chevronDown, logInOutline, logOutOutline, logOutSharp, menu, personCircleOutline, personOutline, statsChart, statsChartSharp } from "ionicons/icons";
import React, { useRef, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { User } from "../models/data";
import { translation } from "../models/translation";
import AuthServ from "../services/auth";
import { isStaticLingualPage, staticLingualUrl } from "../utlities/multilingualUrl";


interface HeaderProps {
    loginB?: boolean
    user?: User | null,
    signIn?: any | null,
    removeUser?: any | null,
    updateLan?: any

}
const Header: React.FC<HeaderProps> = ({ loginB = true, user = null, signIn, removeUser,updateLan }) => {

    const siteText = translation();  // Call the hook
    const lan = siteText.lan;
    

    const languages = [
        {
            name: 'Deutsch',
            ext: '/de'
        },
        {
            name: 'Français',
            ext: '/fr'
        },
        {
            name: 'English',
            ext: '/en'
        },

    ]

    const history = useHistory();

    const pathName = useLocation().pathname;

    const authServ = new AuthServ();

    const isAccountPage = () => {
        if (pathName.indexOf('account') < 0) return false;
        return true
    }

    const handleSignOut = async () => {
        localStorage.removeItem('unregisteredUser');
        await authServ.unSetUser();
        setPopoverSecOpen(false)
        signIn(false);
        removeUser();
        history.push(lan + '/');

    }

    const navigateDissmisMain = (link: any) => {
        setPopoverOpen(false)
        history.push(link.link);
    }

    const navigateDissmisSecondary = (link: any) => {
        setPopoverSecOpen(false)
        history.push(link.link);
    }

    const switchLan = async (e: any) => {
        let targetlan = e;
      
        if (targetlan === lan) {
            return;
        } else if (pathName==='/' || pathName===`${lan}/home`) {
            window.location.href = e
        } else {

            let lanstr = lan.replace("/", "")
            let targetLanKey = targetlan.replace("/", "")

            let staticPageUrl = isStaticLingualPage(pathName, lanstr, targetLanKey)

            
            if (staticPageUrl.length > 0) {
                window.location.href = staticPageUrl
            } else {
                let newPathName=pathName.replace(`/${lanstr}`,`/${targetLanKey}`);
                
                let lastCharacters=newPathName.slice(-3)
                if(lastCharacters===`-${lanstr}`){
                    newPathName=newPathName.slice(0,-3)+`-${targetLanKey}`
                }
                window.location.href = newPathName
                
            }

        }
    }


    const popover = useRef<HTMLIonPopoverElement>(null);
    const popoverSecondary = useRef<HTMLIonPopoverElement>(null);
    const lanPopover = useRef<HTMLIonPopoverElement>(null);

    const [popoverOpen, setPopoverOpen] = useState(false);
    const openPopover = (e: any) => {
        popover.current!.event = e;
        setPopoverOpen(true);
    };

    const [popoverSecOpen, setPopoverSecOpen] = useState(false);

    const [lanPopoverOpen, setLanPopoverOpen] = useState(false);

    const openPopoverSec = (e: any) => {
        popoverSecondary.current!.event = e;
        setPopoverSecOpen(true);
    };

    const openLanPopover = (e: any) => {
        lanPopover.current!.event = e;
        setLanPopoverOpen(true);
    };

    const openLanPopoverOnMobile = () => {
        //setPopoverOpen(false)
        setLanPopoverOpen(true)
    }
    return (
        <>
            <IonHeader   className="ion-no-border">
                <IonToolbar mode="md" color={"light"} className='swHeader  ion-padding-start ion-padding-end'>
                    <IonButtons slot='start'>
                        {isAccountPage() && <IonMenuButton></IonMenuButton>
                        }
                        {!isAccountPage() && <IonButton className="hideMenuButton01" color='secondary' fill="clear" onClick={openPopover}><IonIcon slot="icon-only" icon={menu}></IonIcon></IonButton>}
                        <Link to='/'style={{ marginRight: '30px' }} >
                            < IonImg className="navbar_logo" src={`${import.meta.env.BASE_URL}images/swissdonations_logo_01.png`}></IonImg>
                        </Link>
                    </IonButtons>
                    {!isAccountPage() && <IonButtons slot="" color="dark" className="ion-justify-content-center hideMenu01" >
                        <IonButton routerLink={`${lan}/charities`}>{siteText.menuAccountCharitiesTxt}</IonButton>
                        <IonButton routerLink={`${lan}/fundraise`}>{siteText.menuAccountFundraiseTxt}</IonButton>
                        <IonButton routerLink={`${lan}/${staticLingualUrl("giftcard", lan)}`}>{siteText.giftTitle}</IonButton>
                        <IonButton routerLink={`${lan}/funds`}>{siteText.menuAccountThemeFondsTxt}</IonButton>
                        <IonButton className="ion-margin-end" routerLink={`${lan}/${staticLingualUrl("advise", lan)}`}>{siteText.menuAccountConseilTxt}</IonButton>
                        <IonButton className="ion-margin-start" color={"primary"} fill="outline" routerLink={`${lan}/${staticLingualUrl("donate", lan)}`}>{siteText.menuAccountDonateTxt}</IonButton>
                    </IonButtons>}
                    <IonButtons slot="end" className=" ion-hide-md-down ion-margin-end">
                        <IonButton style={{ marginRight: '30px !important' }} className="ion-margin-end" onClick={openLanPopover}>{`${lan.replace("/", "").toUpperCase()}`} <IonIcon sr-only icon={chevronDown}></IonIcon></IonButton>
                    </IonButtons>
                    {user ?
                        <>
                            <IonButtons color="dark" slot="end">

                                <IonText  className="ion-hide-sm-down" >{user.email}
                                </IonText>
                                <IonButton onClick={openPopoverSec}>
                                <IonIcon slot="icon-only" className="ion-margin-end" size="large" color='medium' icon={personCircleOutline}></IonIcon>
                                </IonButton>


                                <IonButton onClick={openPopoverSec} className="ion-margin-start ion-hide-sm-down">
                                    <IonIcon slot="icon-only" icon={appsOutline}></IonIcon>
                                </IonButton>

                            </IonButtons>


                        </>
                        : ''}
                    {loginB && !user ? <>
                        <IonButtons slot='end'>
                            {/*<IonButton className="ion-hide-md-down" color="primary" fill="solid" routerLink={`${lan}/signup`}><IonText color="light">{siteText.createAccBtnTxt}</IonText></IonButton>*/}
                            <IonButton className="ion-hide-sm-down" color="secondary" fill="outline" routerLink={`${lan}/signin`}>
                                <IonText>{siteText.myAccountBtnTxt}</IonText>
                                <IonIcon slot="start" color="secondary" icon={personOutline}></IonIcon>
                            </IonButton>
                        </IonButtons>
                    </> : <></>
                    }
                </IonToolbar>
            </IonHeader>

            {/**login logout popover */}
            <IonPopover ref={popoverSecondary} isOpen={popoverSecOpen} onDidDismiss={() => setPopoverSecOpen(false)} showBackdrop={false}>
                <IonContent>
                    <IonList>
                        {(user && user.code && user.code) && <span className="ion-padding">
                            <IonText>
                                * {siteText.menuGuestAccountTxt}
                            </IonText>
                        </span>}
                        {(user && user.code && user.code) && <IonItem color="primary" routerLink={`${lan}/password_reset`} detail={true} lines="none" type="button">
                            <IonIcon slot="start" md={personCircleOutline}></IonIcon>
                            <IonLabel>{siteText.menuActivateAccountTxt}</IonLabel>
                        </IonItem>}
                        {(user && !user.code) && <IonItem detail={true} type="button" lines='none' onClick={() => navigateDissmisSecondary({ link: `${lan}/account/start` })}>
                            <IonIcon slot='start' ios={statsChart} md={statsChartSharp}></IonIcon>
                            <IonLabel>{siteText.menuAccountHomeTxt}</IonLabel>
                        </IonItem>}
                        <IonItem detail={true} type="button" lines='none' onClick={handleSignOut}>
                            <IonIcon slot='start' ios={logOutOutline} md={logOutSharp}></IonIcon>
                            <IonLabel>{siteText.siteLogOutBtnTxt}</IonLabel>
                        </IonItem>

                    </IonList>
                </IonContent>
            </IonPopover>

            {/**menu popover */}
            <IonPopover ref={popover} isOpen={popoverOpen} showBackdrop={false} onDidDismiss={() => setPopoverOpen(false)}>
                <IonContent className="ion-padding">
                    <IonList>
                        <IonItem detail onClick={openLanPopoverOnMobile}>{`${lan.replace("/", "").toUpperCase()}`}</IonItem>
                        {!user && <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/signin` })}><IonText color={"secondary"} >{siteText.siteLoginBtnTxt} </IonText><IonIcon slot="end" color="secondary" icon={logInOutline}></IonIcon></IonItem>}
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/charities` })}>{siteText.menuAccountCharitiesTxt}</IonItem>
                        {<IonItem onClick={() => navigateDissmisMain({ link: `${lan}/fundraise` })}>{siteText.menuAccountFundraiseTxt}</IonItem>}
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/${staticLingualUrl("giftcard", lan)}` })}>{siteText.giftTitle}</IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/funds` })}>{siteText.menuAccountThemeFondsTxt}</IonItem>
                        <IonItem onClick={() => navigateDissmisMain({ link: `${lan}/${staticLingualUrl("advise", lan)}` })}>{siteText.menuAccountConseilTxt}</IonItem>
                        <IonItem  onClick={() => navigateDissmisMain({ link: `${lan}/${staticLingualUrl("donate", lan)}` })}><IonText color={"primary"}>{siteText.menuAccountDonateTxt}</IonText></IonItem>
                        
                    </IonList>
                </IonContent>
            </IonPopover>

            {/**lan switcher desktop */}
            <IonPopover ref={lanPopover} isOpen={lanPopoverOpen} showBackdrop={false} onDidDismiss={() => { setLanPopoverOpen(false) }}>
                <IonContent className="ion-padding">
                    <IonList>
                        {languages.map((language, key) => {
                            return <IonItem button disabled={lan === language.ext ? true : false} key={key} onClick={() => switchLan(language.ext)} >
                                <IonText color={lan === language.ext ? 'primary' : 'dark'}>{language.name}</IonText>
                            </IonItem>
                        })}
                    </IonList>
                </IonContent>
            </IonPopover>
        </>
    )
}

export default Header;

